import {pollAsync} from '@yourcoach/async-utils';

import type {UseCaptchaOptions} from './types';

import {execute, init as initCaptcha} from './captcha';

export class CaptchaStore {
  isReady = false;

  constructor(
    private readonly key: string,
    private readonly options: UseCaptchaOptions,
  ) {
    this.init();
  }

  private async init() {
    try {
      if (this.isReady) {
        return;
      }

      await initCaptcha(this.key);

      this.isReady = true;
    } catch (err) {
      // TODO: log the error using the new @yourcoach/logger package
    }
  }

  async getToken(action: string): Promise<string> {
    if (this.options.shouldBeMocked) {
      // if the backend receives this token, it will be considered as a valid token
      // and no additional verification will be done
      return 'valid';
    }

    await pollAsync(() => this.isReady, {
      timeout: 30 * 1000,
      timeoutMessage: 'Could not get captcha token!',
    });

    return execute(action);
  }
}
